export default __webpack_public_path__ + "static/media/Product-Stock.2b0710ab.jpg";